import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, Switch } from 'react-router-dom';

import { NotFoundPage } from 'pages';
import { CtHeader, CtIntro, CtFaq, CtLicensePrice } from 'containers';

const ScSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
const ScHeader = styled.header`
  height: 60px;
`;

class IntroPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ScSection>
        <ScHeader>
          <Route path="/" component={CtHeader} />
        </ScHeader>
        <Switch>
          <Route exact path="/" component={CtIntro} />
          <Route exact path="/intro" component={CtIntro} />
          <Route exact path="/intro/faq" component={CtFaq} />
          <Route exact path="/intro/faq/:inner" component={CtFaq} />
          <Route exact path="/intro/faq/:inner/:detail" component={CtFaq} />
          {/* 구축형 */}
          {/* {commonVar.isSaas && <Route exact path="/intro/price" component={CtLicensePrice} />} */}
          {/* <Route exact path="/intro/price" component={CtLicensePrice} /> */}
          <Route component={NotFoundPage} />
        </Switch>
      </ScSection>
    );
  }
}

IntroPage.propTypes = {};
IntroPage.defaultProps = {};

export default IntroPage;



// WEBPACK FOOTER //
// ./src/script/pages/IntroPage.js